import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface SessionExpiredDialogProps {
  open: boolean;
  onConfirm: () => void;
}

export function SessionExpiredDialog({ open, onConfirm }: SessionExpiredDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>Sesión expirada</DialogTitle>
          <DialogDescription>
            Tu sesión ya no es válida. Ingresá nuevamente para continuar trabajando.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4">
          <Button onClick={onConfirm} className="w-full">
            Ir al login
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
